/**
 * TD-2456 — normalize a keyword-cloud query to the token the match rules compare
 * against: lowercased, with the wrapping quotes of a "quoted" (exact-only)
 * keyword stripped.
 *
 * Lives in its own module because the pill HIGHLIGHT (ChipsList's `matchLevel`)
 * and the pill TOGGLE (`togglePillFilter` in SearchResults) must agree on what
 * counts as the same keyword. While they each carried their own copy of this
 * rule they drifted: the highlight folded case, the toggle did not, so clicking
 * a lit pill whose casing differed from the stored keyword appended a
 * near-duplicate instead of clearing it — leaving the pill permanently lit and
 * unclearable from its own row.
 *
 * Mirrors the engine's `matchKeywordCloud` convention (exploreFilterEngine.js):
 * a "quoted" keyword matches only exactly, a bare keyword matches as a substring.
 *
 * @param {unknown} raw - a stored filter keyword
 * @returns {{needle: string, quoted: boolean}}
 */
export function normalizeKeywordQuery(raw) {
  const kw = String(raw).toLowerCase();
  const quoted = kw.length >= 2 && kw.startsWith('"') && kw.endsWith('"');
  return { needle: quoted ? kw.slice(1, -1) : kw, quoted };
}
